export default {
  dots: false,
  autoplay: false,
  centerMode: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: false,
  infinite: false,
  edgeFriction: 0.1,
  responsive: [
    {
      breakpoint: 599,
      settings: {
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1024,
      settings: {
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
};
